var scope_0 = require('/repository/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0f926c4e59db7a89829532c4ba0d5230.js').default;
var scope_1 = require('/repository/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5b03945b2c6200618b4f9b82a6a28dfa.js').default;
var scope_2 = require('/repository/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cf33247a90ca086f7c4b8036147f9b67.js').default;
var scope_3 = require('/repository/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    